<template lang="pug">
v-card(width="1200").mb-3
  v-card-text.pt-1
    v-layout(wrap)
      v-flex.ma-1(xs12 sm6 md4): v-select(label="Status" v-model="status" :items="statusOptionsAll"  outline)
      v-flex.ma-1(xs12 sm3 md2): v-select(label="Freigegeben" v-model="freigabe" :items="freigabeOptionsAll")
      v-flex.ma-1(xs12 sm3 md2): v-select(label="Shop" v-model="kategorie" :items="itTicketKategorien" clearable item-value="id" item-text="name")
      v-flex(xs1)
        v-menu.mr-3(offset-y open-on-hover :disabled="loadingVisitenkarten > 0")
          v-btn(slot="activator" icon :loading="loadingVisitenkarten > 0")
            v-icon vertical_align_bottom
          v-list
            v-list-tile(@click="downloadVisitenkarten(false)"): v-list-tile-title Visitenkarten
            v-list-tile(@click="downloadVisitenkarten(true)"): v-list-tile-title Visitenkarten (Nochmal)
      v-spacer
      v-text-field(
        v-model="searchBestellungen"
        label="Suche"
        single-line
        hide-details
        box
      )

    v-data-table(
        :items="itTicketVorgangs" 
        :headers="headers" 
        must-sort 
        :pagination.sync="pagination" 
        v-model="selected" 
        select-all
        :search="searchBestellungen"
      )
      template(slot="items" slot-scope="props")
        td: v-checkbox(primary hide-details v-model="props.selected")
        td {{ props.item.status }}
        td {{ formatDate(props.item.createdAt) }}
        td: v-btn(@click="startEdit(props.item)" icon): v-icon edit
        td {{ props.item.ticketart || 'Bestellung' }} {{ props.item.id }}
        td {{ formatEur(props.item.summe) }}
        td {{ (props.item.user && props.item.user.vollerName) || (props.item.ticket && props.item.ticket.person && props.item.ticket.person.vollerName) }}
        td {{ formatDate(props.item.deadline)}}

  v-dialog(:value="!!edit" @input="edit = null" max-width="900" lazy)
    v-card(v-if="edit")
      v-card-title {{ edit.ticketart || 'Bestellung' }} {{ edit.id }}
      v-card-text.pt-0
        v-autocomplete(label="Auftraggeber" v-model="edit.userId" :items="[edit.user]" item-text="vollerName" item-value="id" disabled)
        //- v-select(label="Priorität" v-model="edit.prioritaet" :items="[edit.prioritaet||'']")
        //- v-select(label="Ticketart" v-model="edit.ticketart" :items="[edit.ticketart||'']")
        //- v-select(label="Level" v-model="edit.level" :items="[edit.level||'']")
        v-layout(wrap)
          v-flex(xs12 sm6): v-select(label="Status" v-model="edit.status" :items="statusOptions")
          v-flex(xs12 sm6): v-checkbox(label="Freigegeben" v-model="edit.freigabe")
          v-flex(xs12 sm6): input-date(label="Deadline" v-model="edit.deadline")
          v-flex(xs12): v-combobox(label="TrackingIDs" v-model="edit.trackingids" multiple chips)
            template(v-slot:selection="data")
              v-chip(
                :key="JSON.stringify(data.item)"
                v-bind="data.attrs"
                :input-value="data.selected"
                :disabled="data.disabled"
                @click="openLink(data.item)"
              )
                | {{ data.item }}
          template(v-for="rechnung in edit.rechnungenVersendet")
            v-flex(xs12 sm6): v-autocomplete(label="Rechnung versendet an" v-model="rechnung.versendetAn" :items="personen" item-text="vollerName" item-value="id" clearable)
            v-flex(xs12 sm6): input-date(label="Versendet am" v-model="rechnung.versendetAm")
          v-flex(xs12): v-btn(@click="edit.rechnungenVersendet.push({ versendetAn: null, versendetAm: null })")
              v-icon add
              | Rechnung Versendet
          v-flex(xs12): input-date(label="Ausgehändigt am" v-model="edit.ausgehaendigtAm") 
      
        v-data-table(:items="edit.artikelBestellungen" :headers="headersDetails")
          template(slot="items" slot-scope="{ item }")
            td: v-checkbox(v-model="item.bearbeitet")
            td
              template(v-if="item.artikel.anzahlen" single)
                v-select(v-model="item.anzahl" :items="[item.anzahl || 0].concat(item.artikel.anzahlen.map(([anz,pr]) => anz))" clearable)
              template(v-else)
                v-text-field(v-model.number="item.anzahl" single)
            td
              template(v-if="item.artikel.anzahlen") {{formatEur(preisForArtikelanzahl(item))}}
              template(v-else) {{isFinite(item.anzahl) && `× ${formatEur(item.artikel.preis)} = ${formatEur(item.anzahl * item.artikel.preis)}`}}
            td {{item.artikel.name}}
            td
              template(v-for="option in item.optionen")
                template(v-if="option.type === 'projekt'")
                  | {{option.name}}: {{projektName(option.idvalue)}}
                template(v-else-if="option.type === 'checkbox'")
                  | {{option.name}}: {{option.boolean ? 'Ja' : 'Nein'}}
                template(v-else-if="option.type === 'html'")
                  | {{option.name}}:
                  div(v-html="option.string")
                template(v-else)
                  | {{option.name}}:
                  div(style="white-space: pre-line") {{option.string || ''}}
                br
            td
              template(v-if="item.optionen.length")
                v-btn(@click="startEditOptionen(item)" icon): v-icon edit

        v-alert(:value="!edit.freigabe" type="error") Nicht Freigegeben
      v-card-actions
        v-btn(@click="save" color="primary" outline :loading="loading > 0") Speichern

  v-dialog(:value="!!editOptionen" @input="editOptionen = null" max-width="900" lazy)
    v-card(v-if="editOptionen")
      v-card-title {{ edit.ticketart || 'Bestellung' }} {{ edit.id }} {{ editOptionen.item.artikel.name }}
      v-card-text.pt-0
        template(v-for="option in editOptionen.optionen")
          template(v-if="option.type === 'checkbox'")
            v-checkbox(:label="option.name" v-model="option.boolean")
          template(v-else-if="option.type === 'projekt'")
            v-select(:label="option.name" v-model="option.idvalue" :items="projekte" item-text="name" item-value="id" disabled)
          template(v-else-if="option.type === 'textarea'")
            v-textarea(:label="option.name" v-model="option.string")
          template(v-else-if="option.type === 'html'")
            tiptap-input(:label="option.name" v-model="option.string")
      v-card-actions
        v-btn(@click="saveOptionen" color="primary" outline) Übernhemrn
        v-btn(@click="editOptionen = null" outline) Abbrechen

</template>

<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'
import { user } from '../../router'
import moment from 'moment'


export default {
  props: ['extra'],
  mixins: [GraphqlErrorObject],
  data() {
    return {
      user: user,
      edit: null,
      status: null,
      projekte: [],
      editOptionen: null,
      freigabe: null,
      deadline: null,
      kategorie: null,
      loading: 0,
      loadingVisitenkarten: 0,
      selected: [],
      pagination: { sortBy: 'id', descending: true, rowsPerPage: 20 },
      itTicketVorgangs: [],
      searchBestellungen: '',
      statusOptions: [
        { text: 'Neu', value: 'neu' },
        { text: 'In Bearbeitung', value: 'in_bearbeitung' },
        { text: 'Bestellt', value: 'bestellt' },
        { text: 'Erledigt', value: 'erledigt' },
        { text: 'Doppelt', value: 'doppelt' },
        { text: 'Abgebrochen', value: 'abgebrochen' },
      ],
      statusOptionsAll: [
        { text: 'Alle', value: null },
        { text: 'Neu', value: 'neu' },
        { text: 'In Bearbeitung', value: 'in_bearbeitung' },
        { text: 'Bestellt', value: 'bestellt' },
        { text: 'Erledigt', value: 'erledigt' },
        { text: 'Doppelt', value: 'doppelt' },
        { text: 'Abgebrochen', value: 'abgebrochen' },
      ],
      freigabeOptionsAll: [
        { text: 'Alle', value: null },
        { text: 'Ja', value: true },
        { text: 'Nein', value: false },
      ],
      headers: [
        { text: 'Status', value: 'status' },
        { text: 'Vom', value: 'created_at' },
        { text: '', sortable: false },
        { text: 'ID / Bestellnummer', value: 'id' },
        { text: 'Preis', value: 'summe' },
        { text: 'Besteller', value: 'user.vollerName' },
        { text: 'Deadline', value: 'deadline' },
      ],
      headersDetails: [
        { text: 'Bearbeitet', sortable: false },
        { text: 'Anzahl', sortable: false },
        { text: 'Preis', sortable: false },
        { text: 'Artikel', sortable: false },
        { text: '', sortable: false },
        { text: '', sortable: false },
      ]
    }
  },
  apollo: {
    projekte: {
      query: gql`query ExtraItTicketVorgaengeBearbeitenVueProjekte {
        projekte {
          id
          name
        }
      }`
    },
    itTicketKategorien: {
      query: gql`query ExtraItTicketVorgaengeBearbeitenVueItTicketKategorien {
        itTicketKategorien(where: { ancestryNull: true }) {
          id
          name
        }
      }`
    },
    personen: {
      query: gql`query ExtraItTicketCenterBearbeiter {
        personen(where: { art: "mitarbeiter" }) {
          id
          vollerName
        }
      }`,
    },
    itTicketVorgangs: {
      query: gql`query ExtraItTicketVorgaengeBearbeitenVueItTicketVorgangs(
        $kategorieId: ID
        $status: String
        $freigabe: Boolean
      ) {
        itTicketVorgangs(order: "created_at:desc", where: {
          itTicketKategorieId: $kategorieId
          status: $status
          freigabe: $freigabe
        }) {
          id
          createdAt
          prioritaet
          ticketart
          level
          summe
          status
          freigabe
          trackingids
          ausgehaendigtAm
          deadline
          rechnungenVersendet {
            versendetAn
            versendetAm
          }
          itTicket {
            id
            person {
              id
              vollerName
            }
          }
          user {
            id
            vollerName
          }
          artikelBestellungen {
            id
            anzahl
            bearbeitet
            optionen {
              type
              name
              string
              boolean
              idvalue
            }
            artikel {
              id
              name
              preis
              art
              anzahlen
            }
          }
        }
      }`,
      fetchPolicy: 'cache-and-network',
      variables() {
        return {
          kategorieId: this.kategorie,
          status: this.status,
          freigabe: this.freigabe,
        }
      }
    }
  },
  computed: {
    itTicketKategorie() {
      return this.extra && this.extra.options && this.extra.options.it_ticket_kategorie && `${this.extra.options.it_ticket_kategorie}` || null
    },
  },
  methods: {
    openLink(link) {
      window.open(link)
    },
    projektName(id) {
      const projekt = this.projekte.find(p => p.id == id)
      return projekt && projekt.name || ''
    },
    formatEur(value) {
      if (isFinite(value) && !isNaN(value)) {
        return `${(Math.round(value*100)/100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} €`
      } else {
        return ''
      }
    },
    formatDate(date) {
      if (!!date)
        return moment(date).format("DD.MM.YY");
    },
    preisForArtikelanzahl(bestellung) {
      const artikel = bestellung.artikel
      const anzahl = artikel.anzahlen.find(([anz, preis]) => bestellung.anzahl === anz)
      if (anzahl) {
        const preis = anzahl[1]
        return preis === 0 ? preis : preis || artikel.preis
      } else {
        return artikel.preis
      }
    },
    startEdit(item) {
      this.edit = {
        id: item.id,
        prioritaet: item.prioritaet,
        ticketart: item.ticketart,
        level: item.level,
        summe: item.summe,
        userId: item.user && item.user.id,
        user: item.user,
        status: item.status,
        freigabe: item.freigabe,
        deadline: item.deadline,
        trackingids: item.trackingids,
        rechnungenVersendet: item.rechnungenVersendet.map(o => ({ ...o, __typename: undefined })),
        ausgehaendigtAm: item.ausgehaendigtAm.length == 0 ? null : item.ausgehaendigtAm,
        artikelBestellungen: item.artikelBestellungen.map(bestellung => {
          return {
            id: bestellung.id,
            bearbeitet: bestellung.bearbeitet || false,
            anzahl: bestellung.anzahl,
            artikel: bestellung.artikel,
            optionen: bestellung.optionen.map(o => ({ ...o, __typename: undefined }))
          }
        })
      }
    },
    startEditOptionen(item) {
      this.editOptionen = { item: item, optionen: item.optionen.map(o => ({ ...o })) }
    },
    saveOptionen() {
      this.editOptionen.item.optionen = this.editOptionen.optionen
      this.editOptionen = null
    },
    download(name, ext, type, content) {
      const url = window.URL.createObjectURL(new Blob([content], { type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${name.replace(/[^a-z0-9äüöß_ -]+/gi, '-').replace(/-+/, '-').replace(/^-+|-+$/g, '')}.${ext}`)
      document.body.appendChild(link)
      link.click()
    },
    save() {
      this.loading++
      this.gqlClearAllErrors()
      const edit = this.edit
      this.$apollo.mutate({
        mutation: gql`mutation (
            $id: ID,
            $status: String
            $freigabe: Boolean
            $trackingids: [String]
            $deadline: String
            $rechnungenVersendet: [RechnungVersendetInput]
            $ausgehaendigtAm: [String]
            $artikelBestellungen: [ItAuftraegeUpdateInput]
        ) {
          itTicketVorgangUpdate(
            id: $id
            status: $status
            freigabe: $freigabe
            deadline: $deadline
            trackingids: $trackingids
            rechnungenVersendet: $rechnungenVersendet
            ausgehaendigtAm: $ausgehaendigtAm
            artikelBestellungen: $artikelBestellungen
          ) {
            id
            status
            freigabe
            deadline
            trackingids
            ausgehaendigtAm
            rechnungenVersendet {
              versendetAn
              versendetAm
            }
          }
        }`,
        variables: {
          id: edit.id,
          status: edit.status,
          freigabe: edit.freigabe,
          deadline: edit.deadline,
          trackingids: edit.trackingids,
          rechnungenVersendet: edit.rechnungenVersendet,
          ausgehaendigtAm: edit.ausgehaendigtAm,
          artikelBestellungen: edit.artikelBestellungen.map(b => ({ ...b, anzahl: `${b.anzahl || 0}`, artikelId: b.artikel.id, artikel: undefined }))
        },
      }).then((data) => {
        this.loading--
        this.edit = null
        this.$apollo.queries.itTicketVorgangs.refetch()
      }, (error) => {
        this.gqlAddErrors(error)
        alert('Ein Fehler is aufgetreten.')
        this.loading--
      })
    },
    downloadVisitenkarten(bearbeitet) {
      this.loadingVisitenkarten++
      this.gqlClearAllErrors()
      this.$apollo.mutate({
        mutation: gql`mutation (
            $ids: [ID]!
            $bearbeitet: Boolean
        ) {
          itTicketVorgangDownload(
            ids: $ids
            action: "visitenkarten"
            bearbeitet: $bearbeitet
          ) {
            success
            errorCount
            visitenkarten
          }
        }`,
        variables: {
          ids: this.selected.map(s => s.id),
          bearbeitet
        },
      }).then((response) => {
        this.loadingVisitenkarten--
        const visitenkarten = response.data.itTicketVorgangDownload.visitenkarten
        const errorCount = response.data.itTicketVorgangDownload.errorCount
        if (visitenkarten.length) {
          this.download('visitenkarten', 'txt', 'text/plain', visitenkarten.join('\n--------------------------------------------------\n'))
        } else if (!errorCount) {
          alert('Keine Visitenkarten in Auswahl')
        }
        if (errorCount) {
          alert(`${errorCount} Visitenkarten konnten nicht Exportiert werden`)
        }
        this.$apollo.queries.itTicketVorgangs.refetch()
      }, (error) => {
        this.gqlAddErrors(error)
        alert('Ein Fehler is aufgetreten.')
        this.loadingVisitenkarten--
      })
    }
  }
}
</script>
